<template>
  <Modal
    ref="modal"
    :title="$t('modals.share_stream_group_modal.title')"
  >
    <div class="q-pa-sm">
      <StreamSettingsSharedTab
        is-organisation-settings
        :organisation-team-id="organisationTeamId"
        :shared-with-users="sharedWithUsers"
        :stream-type="streamType"
        :theme="theme"
        @update:shared-with-users="sharedWithUsers = $event"
      />
    </div>
    <template #buttons>
      <BaseButton
        :label="$t('global.cancel')"
        new-design
        @click="cancel"
      />
      <BaseButton
        color="primary"
        :label="$t('global.confirm')"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { storeToRefs } from "pinia";

import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import StreamSettingsSharedTab from "shared/components/streams/tabs/StreamSettingsSharedTab.vue";
import { streamTypes } from "shared/constants";
import { useUserStore } from "shared/stores/user";

export default {
  name: "ShareStreamGroupModal",
  components: {
    BaseButton,
    Modal,
    StreamSettingsSharedTab,
  },
  props: {
    streamType: {
      type: Number,
      required: true,
      validator: (value) => Object.values(streamTypes).includes(value),
    },
    sharedWithUsers: {
      type: Array,
      default: () => [],
    },
    organisationTeamId: {
      type: Number,
      default: null,
    },
  },
  emits: ["confirm", "cancel"],
  setup() {
    const userStore = useUserStore();
    const { currentUser, sortedTeam: team } = storeToRefs(userStore);

    return {
      currentUser,
      team,
    };
  },
  data() {
    return {
      localSharedWithUsers: [],
    };
  },
  computed: {
    isSocialGroup() {
      return this.streamType === streamTypes.socialStream;
    },
    theme() {
      return this.isSocialGroup ? "social" : "default";
    },
  },
  async mounted() {
    this.localSharedWithUsers = Array.from(this.sharedWithUsers);

    if (!this.team.length) await this.getTeam();
  },
  methods: {
    confirm() {
      this.$emit("confirm", this.sharedWithUsers);
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.$refs.modal.close();
    },
  },
};
</script>
